
let language = {

    MOVE_FILE_MODAL_CREATE_TO_TITLE: "Create to:",
    MOVE_FILE_MODAL_FOLDER_NAME_PLACEHOLDER: "Folder name",

    MOVE_FILE_MODAL_ROOT_CATALOG_NAME: "File Library",
    
    // 
    MOVE_FILE_MODAL_CONFIRM_BTN: "confirm",
    MOVE_FILE_MODAL_CANCEL_BTN: "cancel",
    MOVE_FILE_MODAL_MOVE_BTN: "move",
    MOVE_FILE_MODAL_CREATE_NEW_FOLDER_BTN: "create new folder",
    
    // 
    MOVE_FILE_MODAL_MOVE_SUCCESS_TIP: "Move success"
};

export { language }